/**
 * Version of the desktop onboarding content (intro, permission flow, and the
 * contextual demo). Bump it when shipping onboarding content every existing
 * desktop user should see: on their next idle launch, a user whose recorded
 * `desktop_onboarding_version` is lower replays onboarding once
 * (see use-onboarding-content-replay.ts and
 * docs/specs/2026-05-04-cursor-led-permissions-design.md).
 *
 * 1 — first versioned release (2026-09). Every user who completed or skipped
 *     onboarding before it shipped is recorded at 0 and replays once.
 * 2 — concierge work-graph rework (2026-09). Users recorded at 1 replay once.
 *     The guided lessons it shipped were later replaced by the contextual
 *     demo, in which Denker looks at the user's displays and offers help.
 */
export const DESKTOP_ONBOARDING_CONTENT_VERSION = 2;
